import React, { useState } from 'react';
import kokurData from '../../resources/kokur.json';
import braudData from '../../resources/braud.json';
import bakkelsiData from '../../resources/bakkelsi.json';
import runstykki from '../../resources/runstykki.json';
import cesarsalatImg from '../../resources/Salat-Vefja/cesarsalat.png';
import pastasalatImg from '../../resources/Salat-Vefja/pastasalat.png';
import vefjaImg from '../../resources/Salat-Vefja/vefja.png';

const CAKE_IMAGES = {
  'Marsipantertur':         '/images/pontunarkokur/marsipan10.JPG',
  'Afmælistertur':          '/images/pontunarkokur/afmæliskaka.jpeg',
  'Afmælistertur með mynd': '/images/pontunarkokur/afmælis-ia.jpg',
  'Brauðtertur':            '/images/pontunarkokur/braudterta.jpeg',
  'Kransakökur':            '/images/pontunarkokur/kranskakaka.jpeg',
};

const SALAT_ITEMS = [

];

const UR_ELDHUSI_ITEMS = [
  { id: 'cesarsalat',  name: 'Cesarsalat',    image: cesarsalatImg,                      price: 1995 },
  { id: 'pastasalat',  name: 'Pastasalat',    image: pastasalatImg,                      price: 1995 },
  { id: 'vefja',       name: 'Vefja',         image: vefjaImg,                           price: 1750 },
  { id: 'supa-eldhus', name: 'Súpa dagsins',  image: '/images/supur/tomat.jpeg',         price: 1550 },
  { id: 'pestosalat',  name: 'Pestó salat',   image: '/images/salat/pesto.JPG' },
  { id: 'raekjusalat', name: 'Rækjusalat',    image: '/images/salat/rækjusalat.JPG',     price: 825  },
  { id: 'skinkusalat', name: 'Skinkusalat',   image: '/images/salat/skinkusalat.JPG',    price: 825  },
  { id: 'tunfisk',     name: 'Túnfiskssalat', image: '/images/salat/tunfisk.JPG',        price: 845  },
];

const TABS = ['Brauð', 'Rúnstýkki', 'Bakkelsi', 'Úr eldhúsi', 'Kökur'];

const inputCls = 'w-full border border-gray-200 rounded-lg px-3 py-1.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-stone-300 focus:border-stone-400';
const Label = ({ children }) => (
  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">{children}</p>
);

// ── Cake configurator ─────────────────────────────────────────────────────────

function CakeConfig({ cake, onAdd, onCancel }) {
  const [size, setSize] = useState('');
  const [filling, setFilling] = useState('');
  const [bottom, setBottom] = useState('');
  const [smjorkrem, setSmjorkrem] = useState('');
  const [text, setText] = useState('');
  const [skreyting, setSkreyting] = useState('');

  const isSykurmassamynd = cake.name === 'Sykurmassamynd';

  const IMAGE_CAKES = ['Afmælistertur með mynd', 'Sykurmassamynd'];

  const handleAdd = () => {
    if (!isSykurmassamynd && !size) return;
    onAdd({
      type: 'cake',
      details: { cake: cake.name, size, filling, bottom, smjorkrem, text, skreyting, needsImage: IMAGE_CAKES.includes(cake.name) },
    });
  };

  return (
    <div className="border-t border-stone-100 mt-3 pt-3 space-y-2">
      {!isSykurmassamynd && (
        <div>
          <Label>Stærð</Label>
          <select className={inputCls} value={size} onChange={e => setSize(e.target.value)}>
            <option value="">Veldu stærð</option>
            {cake.size.map(s => (
              <option key={s.size} value={s.size}>{s.size} – {s.price?.toLocaleString('is-IS')} kr.</option>
            ))}
          </select>
        </div>
      )}
      {cake.fillings && (
        <div>
          <Label>Fylling</Label>
          <select className={inputCls} value={filling} onChange={e => setFilling(e.target.value)}>
            <option value="">Veldu fyllingu</option>
            {cake.fillings.map(f => <option key={f} value={f}>{f}</option>)}
          </select>
        </div>
      )}
      {cake.botnar && (
        <div>
          <Label>Botn</Label>
          <select className={inputCls} value={bottom} onChange={e => setBottom(e.target.value)}>
            <option value="">Veldu botn</option>
            {cake.botnar.map(b => <option key={b} value={b}>{b}</option>)}
          </select>
        </div>
      )}
      {cake.smjorkrem && (
        <div>
          <Label>Smjörkrem</Label>
          <select className={inputCls} value={smjorkrem} onChange={e => setSmjorkrem(e.target.value)}>
            <option value="">Veldu smjörkrem</option>
            {cake.smjorkrem.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
      )}
      {(cake.name === 'Marsipantertur' || cake.name === 'Smjörkremskaka') && (
        <>
          <div>
            <Label>Texti á köku</Label>
            <input className={inputCls} type="text" value={text} onChange={e => setText(e.target.value)} placeholder="t.d. Til hamingju!" />
          </div>
          <div>
            <Label>Skreyting</Label>
            <input className={inputCls} type="text" value={skreyting} onChange={e => setSkreyting(e.target.value)} />
          </div>
        </>
      )}
      <div className="flex gap-2 pt-1">
        <button
          type="button"
          onClick={handleAdd}
          disabled={!isSykurmassamynd && !size}
          className="flex-1 bg-stone-500 hover:bg-stone-600 disabled:opacity-40 text-white text-xs font-semibold py-1.5 rounded-lg transition-colors"
        >
          + Bæta við
        </button>
        <button type="button" onClick={onCancel} className="px-3 py-1.5 text-xs text-gray-400 hover:text-gray-600 transition-colors">
          Hætta við
        </button>
      </div>
    </div>
  );
}

// ── Product card ──────────────────────────────────────────────────────────────

function ProductCard({ image, name, sub, priceLabel, isSelected, onClick, children }) {
  return (
    <div
      className={`rounded-xl border transition-all overflow-hidden cursor-pointer ${
        isSelected ? 'border-stone-400 shadow-md' : 'border-gray-100 hover:border-stone-200 hover:shadow-sm'
      } bg-white`}
      onClick={!isSelected ? onClick : undefined}
    >
      <div className="relative h-36 overflow-hidden bg-gray-50">
        {image ? (
          <img src={image} alt={name} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-gray-200 text-4xl">🍞</div>
        )}
      </div>
      <div className="p-3">
        <p className="text-sm font-semibold text-gray-800 leading-tight">{name}</p>
        {sub && <p className="text-xs text-gray-400 mt-0.5 line-clamp-1">{sub}</p>}
        {priceLabel && <p className="text-xs font-medium text-stone-600 mt-1">{priceLabel}</p>}
        {isSelected ? children : (
          <button
            type="button"
            onClick={onClick}
            className="mt-2 w-full text-xs font-semibold text-stone-600 hover:text-stone-800 py-1 border border-stone-200 rounded-lg hover:bg-stone-50 transition-colors"
          >
            Velja
          </button>
        )}
      </div>
    </div>
  );
}

// ── Quantity adder (bread / bakkelsi / minidonuts) ────────────────────────────

function QtyAdder({ onAdd, onCancel }) {
  const [qty, setQty] = useState(1);
  return (
    <div className="border-t border-stone-100 mt-3 pt-3">
      <Label>Magn</Label>
      <div className="flex gap-2 items-center">
        <button type="button" onClick={() => setQty(q => Math.max(1, q - 1))} className="w-8 h-8 rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 font-bold transition-colors">−</button>
        <span className="w-8 text-center text-sm font-semibold text-gray-800">{qty}</span>
        <button type="button" onClick={() => setQty(q => q + 1)} className="w-8 h-8 rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 font-bold transition-colors">+</button>
      </div>
      <div className="flex gap-2 mt-3">
        <button type="button" onClick={() => onAdd(qty)} className="flex-1 bg-stone-500 hover:bg-stone-600 text-white text-xs font-semibold py-1.5 rounded-lg transition-colors">
          + Bæta við
        </button>
        <button type="button" onClick={onCancel} className="px-3 py-1.5 text-xs text-gray-400 hover:text-gray-600 transition-colors">
          Hætta við
        </button>
      </div>
    </div>
  );
}

// ── Main catalog ──────────────────────────────────────────────────────────────

export default function ProductCatalog({ onAdd }) {
  const [tab, setTab] = useState('Brauð');
  const [selected, setSelected] = useState(null);

  const deselect = () => setSelected(null);

  const handleAddCake = (product) => { onAdd(product); deselect(); };

  const handleAddBread = (breadName, qty) => {
    onAdd({ type: 'bread', details: { bread: breadName, quantity: qty } });
    deselect();
  };

  const handleAddBakkelsi = (item, qty) => {
    onAdd({ type: 'bakkelsi', details: { name: item.name, quantity: qty } });
    deselect();
  };

  const handleAddRunstykki = (item, qty) => {
    onAdd({ type: 'runstykki', details: { name: item.name, quantity: qty } });
    deselect();
  };

  const handleAddMinidonuts = (qty) => {
    onAdd({ type: 'minidonut', details: { quantity: qty } });
    deselect();
  };

  const handleAddSalat = (item, qty) => {
    onAdd({ type: 'salat', details: { name: item.name, quantity: qty } });
    deselect();
  };

  const handleAddSupa = (qty) => {
    onAdd({ type: 'supa', details: { name: 'Súpa dagsins', quantity: qty } });
    deselect();
  };

  const handleAddEldhus = (item, qty) => {
    const type = item.id === 'supa-eldhus' ? 'supa' : 'eldhus';
    const details = type === 'supa'
      ? { name: 'Súpa dagsins', quantity: qty }
      : { name: item.name, quantity: qty };
    onAdd({ type, details });
    deselect();
  };

  return (
    <div>
      {/* Tabs */}
      <div className="flex border-b border-gray-100 mb-5">
        {TABS.map(t => (
          <button
            key={t}
            type="button"
            onClick={() => { setTab(t); deselect(); }}
            className={`px-4 py-2.5 text-sm font-medium transition-colors border-b-2 -mb-px ${
              tab === t
                ? 'border-stone-500 text-stone-600'
                : 'border-transparent text-gray-400 hover:text-gray-700'
            }`}
          >
            {t}
          </button>
        ))}
      </div>

      {/* Kökur */}
      {tab === 'Kökur' && (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {kokurData.kokur.filter(cake => CAKE_IMAGES[cake.name]).map(cake => {
            const isSel = selected === cake.name;
            const price = cake.name === 'Sykurmassamynd'
              ? `${cake.size[0]?.price?.toLocaleString('is-IS')} kr.`
              : `frá ${Math.min(...cake.size.map(s => s.price || Infinity)).toLocaleString('is-IS')} kr.`;
            return (
              <ProductCard
                key={cake.name}
                image={CAKE_IMAGES[cake.name]}
                name={cake.name}
                priceLabel={price}
                isSelected={isSel}
                onClick={() => setSelected(cake.name)}
              >
                <CakeConfig cake={cake} onAdd={handleAddCake} onCancel={deselect} />
              </ProductCard>
            );
          })}
        </div>
      )}

      {/* Brauð */}
      {tab === 'Brauð' && (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {braudData.items.map(bread => {
            const isSel = selected === bread.id;
            return (
              <ProductCard
                key={bread.id}
                image={`/images/braud/${bread.images}`}
                name={bread.name}
                sub={bread.description}
                priceLabel={bread.price ? `${bread.price.toLocaleString('is-IS')} kr.` : undefined}
                isSelected={isSel}
                onClick={() => setSelected(bread.id)}
              >
                <QtyAdder onAdd={qty => handleAddBread(bread.name, qty)} onCancel={deselect} />
              </ProductCard>
            );
          })}
        </div>
      )}

      {/* Rúnstýkki */}
      {tab === 'Rúnstýkki' && (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {runstykki.items.map(item => {
            const isSel = selected === item.id;
            return (
              <ProductCard
                key={item.id}
                image={`/images/runstykki/${item.images}`}
                name={item.name}
                sub={item.description}
                isSelected={isSel}
                onClick={() => setSelected(item.id)}
              >
                <QtyAdder onAdd={qty => handleAddRunstykki(item, qty)} onCancel={deselect} />
              </ProductCard>
            );
          })}
        </div>
      )}

      {/* Bakkelsi */}
      {tab === 'Bakkelsi' && (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {bakkelsiData.items.map(item => {
            const isSel = selected === item.id;
            return (
              <ProductCard
                key={item.id}
                image={`/images/bakkelsi/${item.images}`}
                name={item.name}
                sub={item.description}
                priceLabel={item.price ? `${item.price.toLocaleString('is-IS')} kr.` : undefined}
                isSelected={isSel}
                onClick={() => setSelected(item.id)}
              >
                <QtyAdder onAdd={qty => handleAddBakkelsi(item, qty)} onCancel={deselect} />
              </ProductCard>
            );
          })}
        </div>
      )}

      {/* Minidonuts */}
      {tab === 'Minidonuts' && (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <ProductCard
            image="/images/minidonuts.JPG"
            name="Minidonuts"
            sub="Lítil donuts, tilvalin á viðburð"
            priceLabel="275 kr. stk."
            isSelected={selected === 'minidonuts'}
            onClick={() => setSelected('minidonuts')}
          >
            <QtyAdder onAdd={handleAddMinidonuts} onCancel={deselect} />
          </ProductCard>
        </div>
      )}

      {/* Salat */}
      {tab === 'Salat' && (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {SALAT_ITEMS.map(item => {
            const isSel = selected === item.id;
            return (
              <ProductCard
                key={item.id}
                image={item.image}
                name={item.name}
                isSelected={isSel}
                onClick={() => setSelected(item.id)}
              >
                <QtyAdder onAdd={qty => handleAddSalat(item, qty)} onCancel={deselect} />
              </ProductCard>
            );
          })}
        </div>
      )}

      {/* Súpa dagsins */}
      {tab === 'Súpa dagsins' && (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <ProductCard
            image="/images/supur/tomat.jpeg"
            name="Súpa dagsins"
            sub="Dagleg súpa — spurðu um tegund"
            isSelected={selected === 'supa'}
            onClick={() => setSelected('supa')}
          >
            <QtyAdder onAdd={handleAddSupa} onCancel={deselect} />
          </ProductCard>
        </div>
      )}

      {/* Úr eldhúsi */}
      {tab === 'Úr eldhúsi' && (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {UR_ELDHUSI_ITEMS.map(item => {
            const isSel = selected === item.id;
            return (
              <ProductCard
                key={item.id}
                image={item.image}
                name={item.name}
                priceLabel={item.price ? `${item.price.toLocaleString('is-IS')} kr.` : undefined}
                isSelected={isSel}
                onClick={() => setSelected(item.id)}
              >
                <QtyAdder onAdd={qty => handleAddEldhus(item, qty)} onCancel={deselect} />
              </ProductCard>
            );
          })}
        </div>
      )}
    </div>
  );
}
